export const customThemeToggleSwitch = {
	root: {
		base: "group flex rounded-lg focus:outline-none",
		active: {
			on: "cursor-pointer",
			off: "cursor-not-allowed opacity-50",
		},
		label: "ms-3 mt-0.5 text-start text-sm font-medium  text-gray-300",
	},
	toggle: {
		base: "relative rounded-full border after:absolute after:rounded-full after:bg-white after:transition-all group-focus:ring-4 group-focus:ring-cyan-500/25",
		checked: {
			on: "after:translate-x-full after:border-white rtl:after:-translate-x-full",
			off: " border-gray-600 bg-gray-700",
			color: {
				blue: "border-cyan-700 bg-cyan-700",
				dark: "bg-dark-700 border-dark-900",
				failure: "border-red-900 bg-red-700",
				gray: "border-gray-600 bg-gray-500",
				green: "border-green-700 bg-green-600",
				light: "bg-light-700 border-light-900",
				red: "border-red-900 bg-red-700",
				purple: "border-purple-900 bg-purple-700",
				success: "border-green-500 bg-green-500",
				yellow: "border-yellow-400 bg-yellow-400",
				warning: "border-yellow-600 bg-yellow-600",
				cyan: "border-cyan-500 bg-cyan-500",
				lime: "border-lime-400 bg-lime-400",
				indigo: "border-indigo-400 bg-indigo-400",
				teal: "bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4",
				info: "border-cyan-600 bg-cyan-600",
				pink: "border-pink-600 bg-pink-600",
			},
		},
		sizes: {
			sm: "h-5 w-9 min-w-9 after:left-px after:top-px after:h-4 after:w-4 rtl:after:right-px",
			md: "h-6 w-11 min-w-11 after:left-px after:top-px after:h-5 after:w-5 rtl:after:right-px",
			lg: "h-7 w-14 min-w-14 after:left-1 after:top-0.5 after:h-6 after:w-6 rtl:after:right-1",
		},
	},
};

export const customModalTheme = {
	root: {
		base: "fixed inset-x-0 top-0 z-50 h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full bg-dark-blue bg-opacity-70 dark:bg-dark-blue dark:bg-opacity-70",
		show: {
			on: "flex bg-modal-bg bg-opacity-50 dark:bg-opacity-80 !bg-dark-blue !bg-opacity-70",
			off: "hidden",
		},
		sizes: {
			sm: "max-w-sm",
			md: "max-w-md",
			lg: "max-w-lg",
			xl: "max-w-xl",
			"2xl": "max-w-2xl",
			"3xl": "max-w-3xl",
			"4xl": "max-w-4xl",
			"5xl": "max-w-5xl",
			"6xl": "max-w-6xl",
			"7xl": "max-w-7xl",
		},
		positions: {
			"top-left": "items-start justify-start",
			"top-center": "items-start justify-center",
			"top-right": "items-start justify-end",
			"center-left": "items-center justify-start",
			center: "items-center justify-center",
			"center-right": "items-center justify-end",
			"bottom-right": "items-end justify-end",
			"bottom-center": "items-end justify-center",
			"bottom-left": "items-end justify-start",
		},
	},
	content: {
		base: "relative h-full w-full p-4 md:h-auto text-white",
		inner: "relative flex max-h-[90dvh] flex-col rounded-lg shadow ",
	},
	body: {
		base: "flex-1 overflow-auto p-6 !bg-modal-bg custom-scrollbar",
		popup: "pt-0",
	},
	header: {
		base: "flex items-start justify-between rounded-t border-b p-5 border-blue-gray !bg-modal-bg text-white dark:!bg-modal-bg",
		popup: "border-b-0 p-2",
		title: "text-xl font-medium text-gray-900 dark:text-white",
		close: {
			base: "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white",
			icon: "h-5 w-5",
		},
	},
	footer: {
		base: "flex items-center space-x-2 rounded-b border-gray-200 p-6 border-blue-gray !bg-modal-bg rounded-b-lg rounded-t-none",
		popup: "border-t",
	},
};

export const customTextInputTheme = {
	base: "flex",
	addon:
		"inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400",
	field: {
		base: "relative w-full",
		icon: {
			base: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3",
			svg: "h-5 w-5 text-gray-500 dark:text-gray-400",
		},
		rightIcon: {
			base: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3",
			svg: "h-5 w-5 text-gray-500 dark:text-gray-400",
		},
		input: {
			base: "block w-full border disabled:cursor-not-allowed disabled:opacity-50",
			sizes: {
				sm: "p-2 sm:text-xs",
				md: "p-2.5 text-sm",
				lg: "p-4 sm:text-base",
			},
			colors: {
				gray: "border-gray-600 bg-input-bg text-gray-400 placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500",
				info: "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-primary-500 focus:ring-primary-500",
				failure:
					"border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-primary-500 focus:ring-primary-500",
				warning:
					"border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-primary-500 focus:ring-primary-500",
				success:
					"border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-primary-500 focus:ring-primary-500",
			},
			withRightIcon: {
				on: "pr-10",
				off: "",
			},
			withIcon: {
				on: "pl-10",
				off: "",
			},
			withAddon: {
				on: "rounded-r-lg",
				off: "rounded-lg",
			},
			withShadow: {
				on: "shadow-sm dark:shadow-sm-light",
				off: "",
			},
		},
	},
};
